import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

// import ngx-translate and the http loader
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgxCaptchaModule} from 'ngx-captcha';

import {AppComponent} from './app.component';
import {AppRoutes} from './app.routing';

import {LayoutsModule} from './layouts/layouts.module';
import {PagesModule} from './pages/pages.module';
import {ErrorsModule} from './errors/errors.module';
import {UserData} from './models';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
    }),
    AppRoutes,
    LayoutsModule,
    PagesModule,
    ErrorsModule,
    NgxCaptchaModule,
    BrowserAnimationsModule
  ],
  providers: [
    UserData,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
